import { BusinessCardService } from "../../../../business-card-management/services/BusinessCardService";

export const getCardQuantity = (companyId) => {
  return BusinessCardService.getBusinessCardsQuantityByCompany(companyId);
};
